// Navigation is now integrated into Header.jsx
const Navigation = () => null;
export default Navigation;
